import type { CogoXyzLibraryItem } from '@cogo/types-v2'

function metadataString(value: unknown): string | null {
  return typeof value === 'string' && value.trim().length > 0
    ? value.trim()
    : null
}

function previewProjectId(previewUrl: string): string | null {
  try {
    const base = typeof window === 'undefined'
      ? 'http://localhost'
      : window.location.origin
    const pathname = new URL(previewUrl, base).pathname
    const match = pathname.match(/^\/ide\/([^/]+)\/?$/)
    if (!match) return null
    const projectId = decodeURIComponent(match[1])
    return projectId.includes('/') ? null : projectId
  } catch {
    return null
  }
}

export function libraryItemSourceProjectId(
  item: CogoXyzLibraryItem,
  projectIds: ReadonlySet<string>,
): string | null {
  const metadata = item.workItem.sourceRef.metadata
  const candidates = [
    item.workItem.workspaceId,
    metadataString(metadata?.projectId),
    metadataString(metadata?.appId),
    metadataString(metadata?.importedProjectId),
    item.workItem.id,
  ]
  for (const candidate of candidates) {
    if (candidate && projectIds.has(candidate)) return candidate
  }

  const previewUrl = item.preview?.previewUrl
  if (!previewUrl) return null
  const projectId = previewProjectId(previewUrl)
  return projectId && projectIds.has(projectId) ? projectId : null
}
